import React from 'react';
import { Box, Typography } from '@saviynt/design-system';
import classname from 'classnames';
import PropTypes from 'prop-types';

import './CertsListSidePanelBodyCommon.css';

function FieldSet({
  title,
  value,
  lineLimitValue,
  suffixComponent,
  isGapRequired,
}) {
  const fieldsetClasses = classname(
    'CertsListSidePanelBodyCommon-fieldset',
    isGapRequired && 'CertsListSidePanelBodyCommon-fieldset--isGapRequired'
  );

  const getFieldSetValue = () => {
    const isString = typeof value === 'string';
    const isElement = React.isValidElement(value);

    if (isString) {
      return (
        <div className='CertsListSidePanelBodyCommon-fieldset--isSuffix'>
          <Typography
            kind='body2'
            desktop='body2-d'
            mobile='body2-d'
            color='--color-foreground-secondary-bold'
            tooltipConfigs={{
              maxWidth: '12rem',
            }}
            lineLimit={lineLimitValue}>
            {`${value}`}
          </Typography>
          {suffixComponent}
        </div>
      );
    }

    if (isElement) {
      return (
        <Box tag='div' className='CertsListSidePanelBodyCommon-fieldsetValue'>
          {value}
          {suffixComponent}
        </Box>
      );
    }

    return null;
  };

  return (
    <Box tag='div' className={fieldsetClasses}>
      <Typography
        kind='body3'
        desktop='body3-d'
        mobile='body3-d'
        color='--color-foreground-neutral-subtle'>
        {title}
      </Typography>
      {getFieldSetValue()}
    </Box>
  );
}

FieldSet.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  lineLimitValue: PropTypes.number,
  suffixComponent: PropTypes.element,
  isGapRequired: PropTypes.bool,
};

FieldSet.defaultProps = {
  title: ' ',
  value: ' ',
  lineLimitValue: 1,
  suffixComponent: null,
  isGapRequired: true,
};

export default FieldSet;
